import { Box, Typography } from "@mui/material";
import { ReactComponent as Database01Icon } from "components/Icons/database-01.svg";
import { ConfirmationModal } from "components/Tooltips/ConfirmationModal";
import { useMessage } from "hooks/intl";
import { useStyles } from "../ImportCsv.styles";

interface Props {
  isOpen: boolean;
  header: string;
  action: () => void;
  onClose: () => void;
}
export function ImportStartedModal({ isOpen, header, action, onClose }: Props) {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <ConfirmationModal
      header={header}
      info={
        <Box className={classes.container}>
          <Box className={classes.iconWrapper}>
            <Database01Icon className={classes.icon} />
          </Box>
          <Typography className={classes.title}>
            {message({ id: "importHasStarted" })}
          </Typography>
          <Typography className={classes.subtitle}>
            {message({ id: "importHasStartedInfo" })}
          </Typography>
        </Box>
      }
      open={isOpen}
      action={action}
      close={onClose}
      cancelText={message({ id: "viewListOfImports" })}
      submitText="continue"
    />
  );
}
